// *******************************************
// **** AI Promotion Section Routes/Paths ****
// *******************************************

export const URL_SCORECARD_LIST = "/pr_score"
export const URL_PROMOTION_MATRIX = "/pr_segment"
